<template>
  <div class="aroma-bind-guide">
    <aroma-secondary-nav title="绑定设备" browser-back-only />
    <main class="aroma-bind-guide__content">
      <header class="aroma-bind-guide__intro">
        <p class="aroma-bind-guide__eyebrow">连接你的睡眠设备</p>
        <h1>开启今晚睡眠记录</h1>
        <p class="aroma-bind-guide__subtitle">绑定设备，获取专属睡眠方案与报告</p>
      </header>
      <div class="aroma-bind-guide__device">
        <img src="@img/aroma-device.png" alt="睡眠管家" @error="imageFailed = true" />
        <div v-if="imageFailed" class="aroma-bind-guide__placeholder">睡眠管家</div>
      </div>
      <section class="aroma-bind-guide__identity">
        <div class="aroma-bind-guide__thumbnail">
          <img v-if="!imageFailed" src="@img/aroma-device.png" alt="" />
          <span v-else>睡眠管家</span>
        </div>
        <div class="aroma-bind-guide__identity-copy">
          <strong>睡眠管家</strong>
          <span>设备编号 {{ sn || '--' }}</span>
        </div>
      </section>
      <section class="aroma-bind-guide__benefits" aria-label="绑定设备后可获得的服务">
        <li v-for="item in benefits" :key="item.text">
          <span class="aroma-bind-guide__benefit-icon">
            <img :src="item.icon" alt="" />
          </span>
          <span class="aroma-bind-guide__benefit-copy">
            <strong>{{ item.text }}</strong>
            <small>{{ item.description }}</small>
          </span>
        </li>
      </section>
      <van-button class="aroma-bind-guide__submit" plain type="primary" block :disabled="!sn" @click="login">
        <van-icon name="phone-o" />
        <span>手机号登录并绑定</span>
      </van-button>
    </main>
  </div>
</template>

<script>
import AromaSecondaryNav from '@/components/aroma-report/AromaSecondaryNav.vue'
import { normalizeSniSn } from '@/utils/sni-session'

export default {
  name: 'AromaBindGuide',
  components: { AromaSecondaryNav },
  data () {
    return {
      imageFailed: false,
      benefits: [
        { icon: require('@img/aroma-benefit-report.svg'), text: '保存个人睡眠报告', description: '设备自动记录数据，云端安全保存' },
        { icon: require('@img/aroma-benefit-plan.svg'), text: '生成个人睡眠方案', description: '结合睡眠数据，提供专属改善建议' },
        { icon: require('@img/aroma-benefit-quality.svg'), text: '持续提升睡眠质量', description: '长期跟踪睡眠趋势，见证每晚进步' }
      ]
    }
  },
  computed: {
    sn () { return normalizeSniSn(this.$route.query.sn) }
  },
  methods: {
    login () {
      if (!this.sn) return
      this.$router.push({ name: 'AromaReportLogin', query: { sn: this.sn } })
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-bind-guide {
  min-height: 100%;
  overflow-x: hidden;
  background: #fff;
}

.aroma-bind-guide__content {
  width: min(100%, 520px);
  margin: 0 auto;
  padding: 12px 24px calc(82px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.aroma-bind-guide__intro { text-align: center; }

.aroma-bind-guide__eyebrow {
  margin: 0 0 1px;
  color: #6b7dfd;
  font-size: 12px;
  line-height: 18px;
}

.aroma-bind-guide__intro h1 {
  margin: 0;
  color: #202b43;
  font-size: 26px;
  font-weight: 700;
  line-height: 34px;
}

.aroma-bind-guide__subtitle {
  margin: 4px 0 0;
  color: #99a3b8;
  font-size: 14px;
  line-height: 20px;
}

.aroma-bind-guide__device {
  position: relative;
  display: flex;
  height: 270px;
  margin: 12px 24px 12px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e7eaf2;
  border-radius: 52px;
  background: #f5f7fb;
  box-shadow: 0 12px 24px rgba(38, 52, 88, .06);
}

.aroma-bind-guide__device img {
  display: block;
  width: auto;
  max-width: 88%;
  height: 94%;
  object-fit: contain;
}

.aroma-bind-guide__placeholder {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: #77819a;
  font-size: 14px;
}

.aroma-bind-guide__identity {
  display: flex;
  min-height: 74px;
  align-items: center;
  gap: 12px;
  padding: 9px 14px;
  border: 1px solid #e5e8ef;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(35, 48, 78, .04);
  box-sizing: border-box;
}

.aroma-bind-guide__thumbnail {
  display: flex;
  width: 54px;
  height: 54px;
  flex: none;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 14px;
  background: #f4f6fa;
}

.aroma-bind-guide__thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.aroma-bind-guide__thumbnail span {
  color: #7a849b;
  font-size: 11px;
  text-align: center;
}

.aroma-bind-guide__identity-copy {
  min-width: 0;
}

.aroma-bind-guide__identity-copy strong {
  display: block;
  color: #26324c;
  font-size: 17px;
  line-height: 24px;
}

.aroma-bind-guide__identity-copy span {
  display: block;
  margin-top: 1px;
  color: #9aa5ba;
  font-size: 13px;
  line-height: 19px;
  overflow-wrap: anywhere;
}

.aroma-bind-guide__benefits {
  margin: 16px 0 20px;
  padding: 4px 14px;
  border: 1px solid #e5e8ef;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(35, 48, 78, .04);
  list-style: none;
}

.aroma-bind-guide__benefits li {
  display: flex;
  min-height: 70px;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
}

.aroma-bind-guide__benefits li + li {
  border-top: 1px solid #e7eaf0;
}

.aroma-bind-guide__benefit-icon {
  display: flex;
  width: 46px;
  height: 46px;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #eff0ff;
}

.aroma-bind-guide__benefits li:nth-child(2) .aroma-bind-guide__benefit-icon { background: #eaf7ff; }
.aroma-bind-guide__benefits li:nth-child(3) .aroma-bind-guide__benefit-icon { background: #f5edff; }

.aroma-bind-guide__benefit-icon img { width: 26px; height: 26px; }

.aroma-bind-guide__benefit-copy { min-width: 0; }

.aroma-bind-guide__benefit-copy strong {
  display: block;
  color: #26324c;
  font-size: 16px;
  line-height: 23px;
}

.aroma-bind-guide__benefit-copy small {
  display: block;
  margin-top: 1px;
  color: #9aa5ba;
  font-size: 12px;
  line-height: 18px;
}

.aroma-bind-guide__submit {
  position: fixed;
  z-index: 25;
  right: 24px;
  bottom: calc(12px + env(safe-area-inset-bottom));
  left: 24px;
  width: auto;
  max-width: 472px;
  margin: 0 auto;
  height: 50px;
  border: 2px solid #6a7cff;
  border-radius: 14px;
  color: #596afd;
  background: #fff;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 8px 18px rgba(89, 106, 253, .08);
}

.aroma-bind-guide__submit .van-icon {
  margin-right: 6px;
  font-size: 18px;
  vertical-align: -2px;
}

.aroma-bind-guide__submit:active { background: #f4f5ff; }

@media (max-width: 374px) {
  .aroma-bind-guide__content { padding-right: 18px; padding-left: 18px; padding-bottom: calc(76px + env(safe-area-inset-bottom)); }
  .aroma-bind-guide__device { margin-right: 18px; margin-left: 18px; }
  .aroma-bind-guide__benefits { padding-right: 14px; padding-left: 14px; }
  .aroma-bind-guide__benefits li { gap: 12px; }
  .aroma-bind-guide__benefit-copy strong { font-size: 17px; }
  .aroma-bind-guide__benefit-copy small { font-size: 13px; }
  .aroma-bind-guide__submit { right: 18px; left: 18px; }
}

@media (max-height: 700px) {
  .aroma-bind-guide__content {
    padding-top: 6px;
    padding-bottom: calc(62px + env(safe-area-inset-bottom));
  }

  .aroma-bind-guide__eyebrow { font-size: 10px; line-height: 14px; }
  .aroma-bind-guide__intro h1 { font-size: 22px; line-height: 28px; }
  .aroma-bind-guide__subtitle { margin-top: 2px; font-size: 12px; line-height: 17px; }
  .aroma-bind-guide__device { height: 200px; margin-top: 8px; margin-bottom: 8px; }
  .aroma-bind-guide__identity { min-height: 60px; padding-top: 7px; padding-bottom: 7px; }
  .aroma-bind-guide__thumbnail { width: 44px; height: 44px; border-radius: 12px; }
  .aroma-bind-guide__identity-copy strong { font-size: 15px; line-height: 20px; }
  .aroma-bind-guide__identity-copy span { font-size: 12px; line-height: 17px; }
  .aroma-bind-guide__benefits { margin-top: 10px; margin-bottom: 12px; padding-top: 2px; padding-bottom: 2px; }
  .aroma-bind-guide__benefits li { min-height: 52px; }
  .aroma-bind-guide__benefit-icon { width: 36px; height: 36px; border-radius: 11px; }
  .aroma-bind-guide__benefit-icon img { width: 20px; height: 20px; }
  .aroma-bind-guide__benefit-copy strong { font-size: 14px; line-height: 19px; }
  .aroma-bind-guide__benefit-copy small { font-size: 11px; line-height: 15px; }
  .aroma-bind-guide__submit { height: 48px; bottom: calc(8px + env(safe-area-inset-bottom)); }
}
</style>
